import useScrollReveal from '../hooks/useScrollReveal';
import useCountUp from '../hooks/useCountUp';

function StatItem({ count, label }) {
  const [ref, isVisible] = useScrollReveal(0.5);
  const value = useCountUp(count, isVisible);
  return (
    <div className="stat-item" ref={ref}>
      <span className="stat-num">{value}</span>
      <span className="stat-label">{label}</span>
    </div>
  );
}

export default function Hero() {
  return (
    <section id="hero">
      <div className="hero-mesh"></div>
      <div className="orb orb-1"></div>
      <div className="orb orb-2"></div>
      <div className="orb orb-3"></div>
      <div className="particle-grid"></div>

      <div className="hero-content">
        <div className="hero-badge">
          <span className="badge-dot"></span> Pronostics verifies & classes
        </div>
        <h1 className="hero-title">
          Les meilleurs coupons<br />pour vos <span className="highlight">evenements sportifs</span>
        </h1>
        <p className="hero-sub">
          Decouvrez les coupons des pronostiqueurs les plus performants.
          Des cotes competitives, simples et efficaces, classees par resultats reels.
        </p>
        <div className="hero-actions">
          <a href="#cta" className="btn-primary">Accéder à l'application →</a>
          <a href="#how-it-works" className="btn-ghost">Comment ca marche</a>
        </div>
      </div>

      <div className="hero-stats">
        <StatItem count={12500} label="Membres actifs" />
        <div className="stat-divider"></div>
        <StatItem count={94} label="% Satisfaction" />
        <div className="stat-divider"></div>
        <StatItem count={340} label="Coupons / semaine" />
      </div>

      <div className="scroll-hint">
        <span>Scroll</span>
        <div className="scroll-line"></div>
      </div>
    </section>
  );
}
